"use strict";

exports.__esModule = true;
exports.SIZE_OPTIONS = void 0;
let SIZE_OPTIONS = exports.SIZE_OPTIONS = /*#__PURE__*/function (SIZE_OPTIONS) {
  SIZE_OPTIONS["SMALL"] = "small";
  SIZE_OPTIONS["MEDIUM"] = "medium";
  return SIZE_OPTIONS;
}({});